import { render, staticRenderFns } from "./OnlineRoomTemp.vue?vue&type=template&id=46c3abf1&scoped=true"
import script from "./OnlineRoomTemp.vue?vue&type=script&lang=js"
export * from "./OnlineRoomTemp.vue?vue&type=script&lang=js"
import style0 from "./OnlineRoomTemp.vue?vue&type=style&index=0&id=46c3abf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c3abf1",
  null
  
)

export default component.exports